<template>
  <InputGroup
    ref="group"
    :bs="wrapperBs"
    :placeholder="selectPlaceholder"
    :input-readonly="!filterable"
    :value="inputValue"
    v-bind="$attrs"
    @focus="handleFocus"
    @blur="handleBlur"
  >
    <template #left>
      <slot name="left" />
    </template>
    <template
      v-if="isOpen"
      #input-footer
    >
      <slot />
    </template>
    <template
      v-if="!$attrs['readonly']"
      #right
    >
      <slot name="right">
        <BeerIcon
          :icon="icon"
          :size="14"
          :bs="{ mr: 11 }"
          color="mute"
        />
      </slot>
    </template>
  </InputGroup>
</template>

<script lang="ts">
  import {
    computed, defineComponent, ref, PropType,
    watch,
  } from 'vue'
  import BeerIcon from '@xhs/yam-beer/cmp/common/Icon/Icon.vue'
  import InputGroup from '../InputGroup/InputGroup.vue'
  import { InputMode } from '../../../compose/options/useOptions'

  export default defineComponent({
    name: 'SelectButton',
    components: {
      InputGroup,
      BeerIcon,
    },
    inheritAttrs: false,
    props: {
      bs: {
        type: Object,
        default: () => ({}),
      },
      inputMode: {
        type: String as PropType<InputMode>,
        default: 'select',
      },
      filterText: {
        type: String,
      },
      value: {},
      isOpen: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
        required: false,
      },
    },
    setup(props, { attrs }) {
      const focused = ref(false)
      const group = ref()
      const filterable = computed(
        () => {
          if (props.inputMode === 'select') {
            return false
          }
          return focused.value || props.isOpen
        },
      )
      watch(() => props.isOpen, open => {
        if (open) {
          group.value.focus()
        }
      })
      const selectPlaceholder = computed(
        () => {
          if (props.placeholder) {
            return props.placeholder
          }
          if (filterable.value) {
            if (props.value) {
              return props.value
            }
            if (props.inputMode === 'filter') {
              return '筛选...'
            }
            if (props.inputMode === 'search') {
              return '搜索...'
            }
          }
          return '请选择选项'
        },
      )
      const icon = computed(
        () => {
          if (filterable.value) {
            if (props.inputMode === 'filter') {
              return 'filtrate'
            }
            if (props.inputMode === 'search') {
              return 'search'
            }
          }
          return 'arrow-down-m'
        },
      )
      const value = computed(() => {
        if (filterable.value) {
          return props.filterText
        }
        return props.value
      })
      return {
        wrapperBs: computed(() => {
          let cursor: string|undefined = 'pointer'
          if (attrs.disabled) {
            cursor = 'not-allowed'
          }
          if (attrs.readonly) {
            cursor = undefined
          }
          return {
            cursor,
            input: {
              cursor: 'unset',
            },
            ...props.bs,
          }
        }),
        group,
        selectPlaceholder,
        filterable,
        inputValue: value,
        icon,
        handleFocus() {
          focused.value = true
        },
        handleBlur() {
          focused.value = false
        },
      }
    },
  })
</script>
